import { get, isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import '../eq-icons.css'
import { getLinearGradientFromGradientArray } from '../utils/helpers'
function FirstTable({ training, slowTraining }) {
    const [chrono, setChrono] = useState([])
    const [hr, setHr] = useState([])
    const [shoeing, setShoeing] = useState([])
    const [insightItems, setInsightItems] = useState([])
    var asterisksCount = slowTraining ? 0 : 3;
    useEffect(() => {
        let insightItems = get(training, 'insight_items', [])

        if (!isEmpty(insightItems)) {
            setInsightItems(insightItems)
            setChrono([...insightItems].filter(e => ['speed', 'sectionals', 'averages', 'splitTimes', 'general'].includes(get(e, 'insight_parameter.category'))))
            setHr([...insightItems].filter(e => ['heartRate', 'recovery'].includes(get(e, 'insight_parameter.category'))))
            setShoeing([...insightItems].filter(e => ['locomotion'].includes(get(e, 'insight_parameter.category'))))
        }
    }, [training])

    function getParameterName(row) {
        var name = get(row, 'insight_parameter.short_name_translated', get(row, 'insight_parameter.name_translated'));
        var insightParameter = row.insight_parameter;

        if (insightParameter.name == "insight.max_speed") {
            name += "  " + "*".repeat(asterisksCount);
            asterisksCount++;
        }

        if (insightParameter.name == "insight.stride_frequency_at_60") {
            name += "  " + "*".repeat(asterisksCount);
            asterisksCount++;
        }

        return name ?? "-";

    }




    const sections = [
        {
            icon: "/icons8-timer-64.png",
            rows: chrono
        },
        {
            icon: "/icons8-heart-rate-80.png",
            rows: hr
        },
        {
            icon: "/horseshoe.png",
            rows: shoeing
        },
    ]

    //Meta
    const insightLength = insightItems.length

    const itemsPerRow = insightLength % 3 === 0 ? 3 : insightLength % 2 === 0 ? 2 : 3
    const gridConfigs = {
        2: 'grid-cols-2',
        3: 'grid-cols-3'
    };
    const gridLength = gridConfigs[itemsPerRow] || 'grid-cols-3';
    return (
        <div className='border-2 overflow-hidden border-redish rounded-md'>

            {
                !slowTraining ?
                    sections.map((section, index) => (
                        <table key={index} className={`border-collapse w-full ${index !== sections.length - 1 && "border-b-[1px] border-redish"} `}>
                            {section.rows.map((row, i) => (
                                <tr key={i} className='overflow-hidden'>
                                    {i === 0 && <td rowSpan={section.rows.length} className='w-[5%] text-center bg-gradient relative '>
                                        <div className='w-6 h-6 overflow-hidden z-20' style={{ backgroundImage: `url(${section.icon})`, backgroundSize: 'contain' }}>
                                        </div>
                                    </td>}
                                    <td className='text-xs font-normal w-[17.5%] text-center'>{getParameterName(row)}</td>
                                    <td className='text-xs font-semibold w-[19%] text-center ps-0 pe-0'>{get(row, 'formatted_value','-')}</td>
                                    <td className='text-xs font-semibold text-center w-[58.5%] '>{row.hasOwnProperty('text') ? row?.text : <Slider item={row}></Slider>}</td>
                                </tr>
                            ))}
                        </table>
                    )) : <div >


                        {/* Body Grid: 3 or 2  Vertical Columns */}
                        <div className={`grid ${gridLength}`}>

                            {insightItems.map((row, rIdx) => (

                                <div
                                    key={rIdx}
                                    className={`grid grid-cols-2   ${rIdx > ((insightLength - itemsPerRow) - 1) ? ' ' : 'border-b-[1px]'} border-redish/20 last:border-0 ${(rIdx + 1) % itemsPerRow !== 0 ? 'border-e-[1px] border-e-redish/20' : ''}  `}
                                >
                                    <div className="flex items-center text-[10px] font-medium flex-1 overflow-hidden  text-gray-700  leading-tight relative border-e-[.5px] gap-2" >
                                        <div className="icon text-[9px] w-[50%] shrink-0 h-full bg-gradient flex justify-center items-center text-center" >
                                            <span className={`eq-${row?.insight_parameter?.icon} eq-icon-2 text-white font-semibold `} >
                                                <span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
                                        </div>
                                        <span className='text-slate-900 text-[9.5px] ms-auto me-auto text-center font-semibold'>
                                            {getParameterName(row, rIdx)}
                                        </span>
                                    </div>

                                    <div className="p-1.5 flex flex-1 flex-col justify-center text-center">
                                        <span className="text-[9.5px] font-semibold text-gray-900 mb-1">
                                            {get(row, 'formatted_value','-')}
                                        </span>

                                    </div>
                                </div>
                            ))}

                            {insightItems.length === 0 && (
                                <div className="p-4 text-center text-[10px] text-gray-400 italic">
                                    No data available
                                </div>
                            )}
                        </div>

                    </div>
            }

        </div >
    )

}


function Slider({ item }) {
    return <div className='flex items-center gap-1 mb-2'>
        <p style={{ fontSize: "10px" }} className=' font-normal w-16 text-right mr-1'>{get(item, 'min')}</p>
        <StyledDiv gradients={get(item, 'gradient_colors', [])}>
            <div style={{ left: get(item, 'value', 0) + '%', backgroundColor: get(item, 'cursor_color', 'lightblue') }} className={`w-[14px] h-[14px] border-gray-200 top-[-3px] border-2 rounded-full  absolute z-10 shadow-2xl translate-x-[-50%] `}></div>

            {!isEmpty(item.sections) && item.sections.map(s => (
                <p className='translate-x-[-50%] font-normal ' style={{ fontSize: '9px', position: 'absolute', left: `${s.position}%`, bottom: '-18px' }}>{s.value}</p>
            ))}
        </StyledDiv>
        <p style={{ fontSize: "10px" }} className=' font-normal w-16 text-left ml-1'>{get(item, 'max')}</p>

    </div>

}

function StyledDiv({ gradients, children }) {

    let [str, setStr] = useState('')

    useEffect(() => {
        if (!isEmpty(gradients)) {

            setStr(getLinearGradientFromGradientArray(gradients))
        }
    }, [gradients])

    if (isEmpty(gradients)) return <></>
    return (
        <div className='w-full h-2 rounded-lg relative p-0 m-0  box-border flex-1' style={{ background: str }}>
            {children}
        </div>
    )


}
export default FirstTable